function carouselInit(slide, state, $carouselItems, $leftArrow, $rightArrow, $shortcuts) {
	var slide = slide || globalVar.slide;

	var $carouselItems = $carouselItems || slide.$.find('.carousel-item__js');
	var $leftArrow = $leftArrow || slide.$.find('.carousel-arrow-left__js');
	var $rightArrow = $rightArrow || slide.$.find('.carousel-arrow-right__js');
	var $shortcuts = $shortcuts || slide.$.find('.carousel-shortcut__js');

	var validShortcuts = $shortcuts && $shortcuts.length > 0;

	slide.data.carousel = slide.data.carousel || {};
	var state = slide.data.carousel;

	state.activePos = state.activePos || 0;

	$leftArrow.on('click.carousel-arrow-left', function () {
		move('left', slide, state, $carouselItems, $shortcuts);
	});
	$rightArrow.on('click.carousel-arrow-right', function () {
		move('right', slide, state, $carouselItems, $shortcuts);
	});

	if (!validShortcuts) return;
	$($shortcuts[0]).addClass('active');

	$shortcuts.each(function (idx, shortcut) {
		shortcut.addEventListener('click', function () {
			move(idx, slide, state, $carouselItems, $shortcuts);
		});
	});
}

function move(direction, slide, state, $carouselItems, $shortcuts) {
	var slide = slide || globalVar.slide;
	var state = state || slide.data.carousel;
	var $carouselItems = $carouselItems || slide.$.find('.carousel-item__js');
	var $shortcuts = $shortcuts ? $shortcuts : slide.$.find('.carousel-shortcut__js');
	var validShortcuts = $shortcuts && $shortcuts.length > 0;

	validShortcuts && $($shortcuts[state.activePos]).removeClass('active');

	var stringInput = typeof direction === 'string';

	if (stringInput) state.activePos = leftOrRight(direction, $carouselItems.length, state.activePos);
	else state.activePos = direction;

	$carouselItems[state.activePos].style.left = '0%';

	validShortcuts && $($shortcuts[state.activePos]).addClass('active');

	scrollCarouselTo($carouselItems, state.activePos);
}

function leftOrRight(direction, carouselLength, activePos) {
	var newPos;
	var beginningOfList = activePos === 0;
	var endOfList = activePos === carouselLength - 1;

	if (direction === 'left' && !beginningOfList) newPos = activePos - 1;
	else if (direction === 'left') newPos = carouselLength - 1;
	else if (!endOfList) newPos = activePos + 1;
	else newPos = 0;

	return newPos;
}

function scrollCarouselTo($carouselItems, pos) {
	$carouselItems.each(function (idx, item) {
		var posDif = idx - pos;
		var newPercentage = '' + posDif + '00' + '%';
		item.style.left = newPercentage;
	});
}
